import { Box, Collapse, CircularProgress } from '@mui/material'
import React, { useEffect, useState } from 'react'
import SanitizeHtml from '../../Base/SanitizeHtml/SanitizeHtml'
import { useDispatch, useSelector } from 'react-redux'
import { postData } from '../../../../js/helpers/apiHelper'
import {
  setSelectedVehicle,
  setAlternateVehicle,
  setUpsellUpgraded,
} from '../../../../js/lib/redux/slices/booking'
import * as lib from '../../../../js/lib/lib'
import isTransmissionAuto from '../../../../js/helpers/isTransmissionAuto'

const Upsell = ({
  handleSuccess = () => {},
  handleError = () => {},
  inpath,
}) => {
  const { configuration, dictionary, records, token } =
    window.bookingData || window.inpathData
  const {
    selectedVehicle,
    alternateVehicle,
    selectedExtras,
    isPrepaid: isPrepaidStore,
    type,
    upsellUpgraded: upgraded,
    inpathCars,
    latestSearch,
  } = useSelector((state) => state.booking)

  const dispatch = useDispatch()

  const { brands, types } = records

  const [isLoading, setIsLoading] = useState(false)
  // const [upgraded, setUpgraded] = useState(false)
  const [showMore, setShowMore] = useState(true)
  const [showMoreExtras, setShowMoreExtras] = useState(false)
  const [initialVehicleCharge, setInitialVehicleCharge] = useState(0)
  const [upsellVehicleCharge, setUpsellVehicleCharge] = useState(0)
  const [upgradeText, setUpgradeText] = useState('')
  const [upgradeMilesText, setUpgradeMilesText] = useState('')

  const upsellVehicle =
    type === 'inpath'
      ? inpathCars.find((i) => {
          if (upgraded) {
            return (
              i.groupName === alternateVehicle.car.upsellGroup &&
              i.brandCode === alternateVehicle.brandName
            )
          }
          return (
            i.groupName === selectedVehicle.car.upsellGroup &&
            i.brandCode === selectedVehicle.brandName
          )
        })
      : records.cars.find((i) => {
          if (upgraded) {
            return (
              i.groupName === alternateVehicle.car.upsellGroup &&
              i.brandCode === alternateVehicle.brandName
            )
          }
          return (
            i.groupName === selectedVehicle.car.upsellGroup &&
            i.brandCode === selectedVehicle.brandName
          )
        })

  const upsellUpgradeDetails = { upsellAwardMiles: 2500 }

  const dailyRateDifference = () => {
    return (
      (upsellVehicleCharge - initialVehicleCharge) / selectedVehicle.duration
    )
  }

  const isPrepaid = () => {
    if (isPrepaidStore) {
      return upsellVehicle.prepaidPrice
    }
    return upsellVehicle.nonPrepaidPrice
  }

  const getBrand = () => {
    return brands?.find((b) => b.brandCode === upsellVehicle.brandCode)
  }

  const toggleContent = () => {
    setShowMore(!showMore)
  }

  const toggleContentExtras = () => {
    setShowMoreExtras(!showMoreExtras)
  }

  const onUpgradeVehicle = () => {
    upgradeCall()
    setShowMore(true)
  }

  const onCancelUpgradeVehicle = () => {
    cancelCall()
    setShowMore(true)
  }

  const upsellFetchData = async () => {
    if (!upsellVehicle) return
    setIsLoading(true)
    try {
      let inpathPayload = {}
      if (inpath && window.inpathData) {
        const {
          isGREngine,
          tarrifs,
          cdp,
          promoCode,
          goldNumber,
          MBLoginDataModel,
          currentValues,
        } = window.inpathData || {}

        const criteria = latestSearch || currentValues || {}

        const dropOffDate = criteria?.dropOffDate
        const dropOffTime = criteria?.dropOffTime
        const pickUpDate = criteria?.pickUpDate
        const pickUpTime = criteria?.pickUpTime
        const dropOffLocation = criteria?.dropOffLocation
        const pickUpLocation = criteria?.pickUpLocation

        inpathPayload = {
          dropOffDate,
          dropOffLocation,
          dropOffTime,
          pickUpDate,
          pickUpLocation,
          pickUpTime,
          mbData: MBLoginDataModel,
          isGREngine: isGREngine ?? false,
          tarrifs,
          cdp,
          promoCode,
          goldNumber,
        }
      }

      const payload = {
        amenities: selectedExtras.map(({ code, quantity }) => ({
          Code: code,
          Quantity: quantity,
        })),
        rateReference: upsellVehicle.rateReference,
        vehicleGroup: upsellVehicle.groupName,
        brandCode: upsellVehicle.brandCode,
        isPrepaid: isPrepaidStore,
        isAlternative: true,
        acriss: upsellVehicle.acriss,
        token,
        ...inpathPayload,
      }

      let response = null

      if (type === 'inpath') {
        response = await postData(configuration.endpointInpathBookNow, payload)
      } else {
        response = await postData(configuration.endpointGetSingleRate, payload)
      }

      if (response.hasError) {
        handleError(response.errorMessages)
        return
      }

      if (!response.hasError && type === 'inpath') {
        dispatch(setAlternateVehicle(response.data.renderData))
      } else if (response.success) {
        dispatch(setAlternateVehicle(response.vehicle))
      }

      setInitialVehicleCharge(
        isPrepaidStore
          ? selectedVehicle.car.prepaidPrice.vehicleCharge
          : selectedVehicle.car.returnPrice.vehicleCharge
      )
      setUpsellVehicleCharge(
        isPrepaidStore
          ? response.vehicle?.car?.prepaidPrice?.vehicleCharge
          : response.vehicle?.car?.returnPrice?.vehicleCharge
      )

      handleSuccessInternal()
    } catch (err) {
      console.error(err)
      handleErrorInternal([err.message])
    }
  }

  const upgradeCall = async () => {
    setIsLoading(true)
    try {
      const payload = {
        token,
      }

      const response = await postData(
        configuration.endpointSwapVehicles,
        payload
      )

      if (response.hasError) {
        handleError(response.errorMessages)
        return
      }

      if (response.data.success) {
        swapVehicles()
        dispatch(setUpsellUpgraded(true))
      }
      handleSuccessInternal()
    } catch (err) {
      console.log(err)
      handleErrorInternal([err.message])
    }
  }

  const cancelCall = async () => {
    setIsLoading(true)
    try {
      const payload = {
        token,
      }

      const response = await postData(
        configuration.endpointSwapVehicles,
        payload
      )

      if (response.data.success) {
        swapVehicles()
        dispatch(setUpsellUpgraded(false))
      }
      handleSuccessInternal()
    } catch (err) {
      console.error(err)
      handleErrorInternal([err.message])
    }
  }

  const handleSuccessInternal = () => {
    setIsLoading(false)
    handleSuccess()
  }

  const handleErrorInternal = (messages) => {
    setIsLoading(false)
    handleError(messages)
  }

  const swapVehicles = () => {
    const currentSelected = selectedVehicle
    dispatch(setSelectedVehicle(alternateVehicle))
    dispatch(setAlternateVehicle(currentSelected))
  }

  useEffect(() => {
    if (selectedVehicle.car.upsellGroup) {
      upsellFetchData()
    }
  }, [])

  useEffect(() => {
    if (initialVehicleCharge && upsellVehicleCharge) {
      setUpgradeText(
        `${dictionary.upsellUpgradeText} ${lib.formatCurrency(
          selectedVehicle.car.vehicleChargeCurrency,
          dailyRateDifference()
        )} ${dictionary.upsellUpgradePerDay}`
      )
      setUpgradeMilesText(
        `${dictionary.upsellUpgradeMilesText} ${upsellUpgradeDetails.upsellAwardMiles} ${dictionary.upsellUpgradeMilesSuffix}`
      )
    }
  }, [
    initialVehicleCharge,
    upsellVehicleCharge,
    dictionary,
    selectedVehicle.duration,
  ])

  return (
    <>
      {upsellVehicle && (
        <>
          <div className={`b-upsell ${upgraded ? 'b-upsell--upgraded' : ''}`}>
            {isLoading && (
              <div className="b-upsell__loading-overlay">
                <CircularProgress />
              </div>
            )}
            <div className="b-upsell__header">
              <div className="b-upsell__title">
                {!upgraded && (
                  <div className="b-upsell__tag">
                    {dictionary.upsellTagLabel}
                  </div>
                )}
                {upgraded ? (
                  <SanitizeHtml
                    tag="span"
                    html={dictionary.upsellUpgradeConfirmText}
                    className="b-upsell__title__main"
                  />
                ) : (
                  <SanitizeHtml
                    tag="span"
                    html={upgradeText}
                    className="b-upsell__title__main"
                  />
                )}
                {upgraded ? (
                  <span className="b-upsell__title__sub">
                    {upsellVehicle.model}
                  </span>
                ) : (
                  <SanitizeHtml
                    tag="span"
                    html={upgradeMilesText}
                    className="b-upsell__title__sub"
                  />
                )}
              </div>
              <div className="b-upsell__btn">
                {upgraded ? (
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-icon-end"
                    onClick={onCancelUpgradeVehicle}
                    title={dictionary.upsellUpgradeCancelButtom}>
                    {dictionary.upsellUpgradeCancelButtom}
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-primary btn-icon-end"
                    onClick={onUpgradeVehicle}
                    title={dictionary.upsellUpgradeButton}>
                    {dictionary.upsellUpgradeButton}
                  </button>
                )}
                {!upgraded && (
                  <button
                    type="button"
                    className={`btn-clear b-upsell__toggle ${
                      showMore ? 'show' : ''
                    } `}
                    onClick={toggleContent}
                    aria-expanded={showMore}
                    aria-label={
                      showMore ? 'Hide upsell details' : 'Show upsell details'
                    }>
                    <i className="icon-arrow-down arrow"></i>
                  </button>
                )}
              </div>
            </div>
            <Collapse in={showMore && !upgraded}>
              <Box>
                <div className="b-upsell__separator"></div>
                <div className="b-upsell__content">
                  <div className="b-upsell__image">
                    <img
                      src={upsellVehicle.modelImage}
                      alt={upsellVehicle.model}
                    />
                  </div>
                  <div className="b-upsell__details">
                    <div className="b-upsell__details__title">
                      <div className="b-upsell__details__model">
                        <span>{upsellVehicle.model} </span>
                        <span className="b-upsell__details__model--similar">
                          {upsellVehicle.similarText}
                        </span>
                      </div>
                      <div className="b-upsell__details__logo">
                        {getBrand() && (
                          <img
                            src={getBrand().brandLogo}
                            alt={getBrand().brandCode}
                          />
                        )}
                      </div>
                    </div>
                    <div className="b-upsell__details__group">
                      <span>{upsellVehicle.acriss}</span>
                    </div>
                    <ul className="b-upsell__details__list">
                      {upsellVehicle.passengers && (
                        <li>
                          <div className="pair">
                            <i className="icon-passenger"></i>
                            <span>{upsellVehicle.passengers}</span>
                          </div>
                        </li>
                      )}
                      {(upsellVehicle.sLuggage > 0 ||
                        upsellVehicle.luggage > 0) && (
                        <li>
                          {upsellVehicle.luggage > 0 && (
                            <div className="pair">
                              <i className="big icon-suitcase"></i>
                              <span>x{upsellVehicle.luggage}</span>
                            </div>
                          )}
                          {upsellVehicle.sLuggage > 0 && (
                            <div className="pair">
                              <i className="small icon-suitcase"></i>
                              <span>x{upsellVehicle.sLuggage}</span>
                            </div>
                          )}
                        </li>
                      )}
                      {upsellVehicle?.acriss && (
                        <li>
                          <div className="pair">
                            <i className="icon-transmission"></i>
                            <span>
                              {isTransmissionAuto({
                                acriss: upsellVehicle.acriss,
                              })
                                ? dictionary.transmissionAutomatic
                                : dictionary.transmissionManual}
                            </span>
                          </div>
                        </li>
                      )}
                      <li>
                        <div className="pair">
                          <i className="icon-ac"></i>
                          {upsellVehicle.hasAC ? (
                            <span>{dictionary.acYes}</span>
                          ) : (
                            <span>{dictionary.acNo}</span>
                          )}
                        </div>
                      </li>
                      {upsellVehicle.charging && (
                        <li>
                          <div className="pair">
                            <i className="icon-battery-charging"></i>
                            <span>{upsellVehicle.charging}</span>
                          </div>
                        </li>
                      )}
                    </ul>
                  </div>
                  <div className="b-upsell__extras">
                    <ul className="b-upsell__extras__list">
                      {isPrepaid().includes.map((extra, index) => (
                        <li key={index}>
                          <i className="icon-check"></i>
                          <span>{extra}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Box>
            </Collapse>
          </div>
          <div
            className={`b-upsell b-upsell--mobile ${
              upgraded ? 'b-upsell--upgraded' : ''
            }`}>
            {isLoading && (
              <div className="b-upsell__loading-overlay">
                <CircularProgress />
              </div>
            )}
            {!upgraded && (
              <div className="b-upsell__header">
                {dictionary.upsellTagLabel}
                <button
                  type="button"
                  className={`btn-clear b-upsell__toggle ${
                    showMore ? 'show' : ''
                  } `}
                  onClick={toggleContent}
                  aria-expanded={showMore}
                  aria-label={
                    showMore ? 'Hide upsell details' : 'Show upsell details'
                  }>
                  <i className="icon-arrow-down arrow"></i>
                </button>
              </div>
            )}
            {upgraded && (
              <>
                <div className="b-upsell__header">
                  <div className="b-upsell__title">
                    <SanitizeHtml
                      tag="span"
                      html={dictionary.upsellUpgradeConfirmText}
                      className="b-upsell__title__main"
                    />
                  </div>
                </div>
                <div className="b-upsell__separator"></div>
                <div className="b-upsell__content">
                  <div className="b-upsell__details">
                    <div>
                      <div className="b-upsell__details__title">
                        <div className="b-upsell__details__model">
                          <span>{upsellVehicle.model} </span>
                          <span className="b-upsell__details__model--similar">
                            {upsellVehicle.similarText}
                          </span>
                        </div>
                      </div>
                      <div className="b-upsell__details__group">
                        <span>{upsellVehicle.acriss}</span>
                      </div>
                    </div>
                    <div className="b-upsell__image">
                      <img
                        src={upsellVehicle.modelImage}
                        alt={upsellVehicle.model}
                        width={80}
                        height={80}
                      />
                    </div>
                  </div>
                  <div className="b-upsell__btn">
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-icon-end"
                      onClick={onCancelUpgradeVehicle}
                      title={dictionary.upsellUpgradeCancelButtom}>
                      {dictionary.upsellUpgradeCancelButtom}
                    </button>
                  </div>
                </div>
              </>
            )}
            <Collapse in={!showMore && !upgraded}>
              <Box>
                <div className="b-upsell__content b-upsell__content--collapse">
                  <div className="b-upsell__title">
                    {upgraded ? (
                      <SanitizeHtml
                        tag="span"
                        html={dictionary.upsellUpgradeConfirmText}
                        className="b-upsell__title__main"
                      />
                    ) : (
                      <SanitizeHtml
                        tag="span"
                        html={upgradeText}
                        className="b-upsell__title__main"
                      />
                    )}
                    {upgraded ? (
                      <span className="b-upsell__title__sub">
                        {upsellVehicle.model}
                      </span>
                    ) : (
                      <SanitizeHtml
                        tag="span"
                        html={upgradeMilesText}
                        className="b-upsell__title__sub"
                      />
                    )}
                  </div>

                  <div className="b-upsell__image">
                    <img
                      src={upsellVehicle.modelImage}
                      alt={upsellVehicle.model}
                      width={80}
                      height={80}
                    />
                    {getBrand() && (
                      <img
                        src={getBrand().brandLogo}
                        alt={getBrand().brandCode}
                        width={44}
                        height={16}
                      />
                    )}
                  </div>
                </div>
              </Box>
            </Collapse>
            <Collapse in={showMore && !upgraded}>
              <Box>
                <div className="b-upsell__content">
                  <div className="b-upsell__title">
                    {upgraded ? (
                      <SanitizeHtml
                        tag="span"
                        html={dictionary.upsellUpgradeConfirmText}
                        className="b-upsell__title__main"
                      />
                    ) : (
                      <SanitizeHtml
                        tag="span"
                        html={upgradeText}
                        className="b-upsell__title__main"
                      />
                    )}
                    {upgraded ? (
                      <span className="b-upsell__title__sub">
                        {upsellVehicle.model}
                      </span>
                    ) : (
                      <SanitizeHtml
                        tag="span"
                        html={upgradeMilesText}
                        className="b-upsell__title__sub"
                      />
                    )}
                  </div>
                  <div className="b-upsell__separator"></div>
                  <div className="b-upsell__details">
                    <div className="b-upsell__details__title">
                      <div className="b-upsell__details__model">
                        <span>{upsellVehicle.model} </span>
                        <span className="b-upsell__details__model--similar">
                          {upsellVehicle.similarText}
                        </span>
                      </div>
                      <div className="b-upsell__details__logo">
                        {getBrand() && (
                          <img
                            src={getBrand().brandLogo}
                            alt={getBrand().brandCode}
                          />
                        )}
                      </div>
                    </div>
                    <div className="b-upsell__details__group">
                      <span>{upsellVehicle.acriss}</span>
                    </div>
                    <ul className="b-upsell__details__list">
                      {upsellVehicle.passengers && (
                        <li>
                          <div className="pair">
                            <i className="icon-passenger"></i>
                            <span>{upsellVehicle.passengers}</span>
                          </div>
                        </li>
                      )}
                      {(upsellVehicle.sLuggage > 0 ||
                        upsellVehicle.luggage > 0) && (
                        <li>
                          {upsellVehicle.luggage > 0 && (
                            <div className="pair">
                              <i className="icon-suitcase"></i>
                              <span>x{upsellVehicle.luggage}</span>
                            </div>
                          )}
                          {upsellVehicle.sLuggage > 0 && (
                            <div className="pair">
                              <i className="icon-suitcase"></i>
                              <span>x{upsellVehicle.sLuggage}</span>
                            </div>
                          )}
                        </li>
                      )}
                      {upsellVehicle?.acriss && (
                        <li>
                          <div className="pair">
                            <i className="icon-transmission"></i>
                            <span>
                              {isTransmissionAuto({
                                acriss: upsellVehicle.acriss,
                              })
                                ? dictionary.transmissionAutomatic
                                : dictionary.transmissionManual}
                            </span>
                          </div>
                        </li>
                      )}
                      <li>
                        <div className="pair">
                          <i className="icon-ac"></i>
                          {upsellVehicle.hasAC ? (
                            <span>{dictionary.acYes}</span>
                          ) : (
                            <span>{dictionary.acNo}</span>
                          )}
                        </div>
                      </li>
                      {upsellVehicle.charging && (
                        <li>
                          <div className="pair">
                            <i className="icon-battery-charging"></i>
                            <span>{upsellVehicle.charging}</span>
                          </div>
                        </li>
                      )}
                    </ul>
                  </div>
                  <div className="b-upsell__image">
                    <img
                      src={upsellVehicle.modelImage}
                      alt={upsellVehicle.model}
                    />
                  </div>
                  <Collapse in={showMoreExtras}>
                    <Box>
                      <div className="b-upsell__extras">
                        <ul className="b-upsell__extras__list">
                          {isPrepaid().includes.map((extra, index) => (
                            <li key={index}>
                              <i className="icon-check"></i>
                              <span>{extra}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </Box>
                  </Collapse>
                  <button
                    type="button"
                    className={`btn-clear b-upsell__view-more-btn ${
                      showMoreExtras ? 'show' : ''
                    }`}
                    onClick={toggleContentExtras}
                    aria-expanded={showMoreExtras}
                    aria-label={
                      showMoreExtras
                        ? 'Hide extra details'
                        : 'Show extra details'
                    }>
                    {showMoreExtras
                      ? dictionary.asideHideDetails
                      : dictionary.asideShowDetails}
                    <i className="icon-arrow-down arrow" />
                  </button>
                  <div className="b-upsell__btn">
                    {upgraded ? (
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-icon-end"
                        onClick={onCancelUpgradeVehicle}
                        title={dictionary.upsellUpgradeCancelButtom}>
                        {dictionary.upsellUpgradeCancelButtom}
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary btn-icon-end"
                        onClick={onUpgradeVehicle}
                        title={dictionary.upsellUpgradeButton}>
                        {dictionary.upsellUpgradeButton}
                      </button>
                    )}
                  </div>
                </div>
              </Box>
            </Collapse>
          </div>
        </>
      )}
    </>
  )
}

export default Upsell
